import { __assign, __rest } from "tslib";
import * as React from 'react';
/**
 * Represents a user icon next to the given account name.
 */
export var AccountInfo = function (_a) {
    var userName = _a.userName, props = __rest(_a, ["userName"]);
    return (React.createElement("div", __assign({}, props, { className: "account-info" }),
        React.createElement("i", { className: "fas fa-user" }),
        " ",
        userName));
};
//# sourceMappingURL=index.js.map